<template>
  <div class="interal-split">
    <div style="display: flex" class="newRow">
      <h4 style="margin-right: 25px; line-height: 32px">
        Internal Split Calculation
      </h4>
      <div class="text-right" style="flex-grow: 1">
        <base-button
          type="primary"
          class="text-rignt"
          @click="regenerate"
          :disabled="disabled"
          >Regenerate Internal Split</base-button
        >
      </div>
    </div>

    <div
      class="newRow newCard"
      v-for="(item, index) in ContractSplitMedias"
      :key="'splitmedia' + index"
    >
      <div
        class="row description col-sm-12"
        style="color: #423022; margin: 0; padding: 0"
      >
        <div class="col-sm-4">
          <span>{{ index + 1 }}. {{ item.mediaName }} </span>
        </div>
        <div class="col-sm-4">
          <span>Material: </span
          ><label>{{ getMediaTechinologyValue(index) }}</label>
        </div>
        <div class="col-sm-3">
          <span>Location: </span
          ><label>{{ getLocationDescriptionValue(index) }}</label>
        </div>
        <div class="col-sm-1 text-right">
          <el-dropdown trigger="click" :disabled="disabled">
            <span
              >Action <el-icon> <caret-bottom /> </el-icon
            ></span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="copyMedia(index)"
                  >Copy</el-dropdown-item
                >
                <el-dropdown-item @click="deletemedia(index)"
                  >Delete</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <div class="col-sm-12">
          <div style="display: flex; align-items: center">
            <div style="padding-right: 7px">
              <div style="width: 119px">(Append contents)</div>
            </div>
            <div>
              <append :text="item.append" />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <el-table border :data="[item]">
            <el-table-column prop="" label="Bonus" width="65">
              <template #default="scope">
                <base-checkbox
                  v-model="scope.row.isBonus"
                  disabled
                ></base-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="" label="TBC" min-width="40">
              <template #default="scope">
                <base-checkbox
                  v-model="scope.row.isToBeConfirmed"
                  disabled
                ></base-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="period" label="Period" min-width="200">
              <template #default="scope">
                <base-input
                  class="period"
                  :class="{ 'is-error': scope.row.startDate === null }"
                >
                  <mediaperiod
                    v-model="scope.row.dates"
                    :mediaStartDate="scope.row.mediaStartDate"
                    :mediaEndDate="scope.row.mediaEndDate"
                    :disabled="disabled"
                    @changePeriod="changePeriod(index)"
                  />
                </base-input>
              </template>
            </el-table-column>
            <el-table-column prop="noOfDays" label="Days" min-width="50" />
            <el-table-column
              prop="quantity"
              label="Qty/ Sec/Hr"
              min-width="65"
            />
            <el-table-column
              prop="grossRate"
              label="Gross Rate"
              min-width="130"
              :formatter="formatterCellMoney"
            >
              <template #header>
                <div style="color: #3ea1ec">
                  Gross Rate
                  {{
                    mediaJs.unitGrossRate_str(item?.unitRateOptionObject?.type)
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="false"
              prop="loading"
              label="Loading(%)"
              min-width="75"
            >
              <template #header>
                <div style="color: #3ea1ec">Loading(%)</div>
              </template>
              <template #default="scope">
                <div>
                  <base-input
                    v-model="scope.row.loading"
                    :disabled="disabled || useContractInfo.loadingDisabled"
                    @blur="ContractSplitMediaValidate(index, 'loading')"
                    @change="changeLoading(index)"
                    class="base-input"
                    :class="{
                      'has-error':
                        item.validate &&
                        item.validate.filter(
                          (t) => t.field === 'loading' && t.fieldValue !== 0
                        ).length > 0,
                    }"
                  ></base-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="grossItemSum"
              label="Gross Item Sum"
              min-width="100"
              :formatter="formatterCellMoney"
            >
              <template #header>
                <div style="color: #3ea1ec">Gross Item Sum</div>
              </template>
            </el-table-column>
            <el-table-column prop="nettItemSum" min-width="100">
              <template #header>
                <div style="color: #3ea1ec">Nett Item Sum</div>
              </template>
              <template #default="scope">
                <div class="input-currency-noarea">
                  <base-input
                    v-model="scope.row.nettItemSum"
                    :disabled="disabled || useContractInfo.nettItemSumDisabled"
                    @blur="ContractSplitMediaValidate(index, 'nettItemSum')"
                    @change="changeNettItemSum(index)"
                    class="base-input"
                    :class="{
                      'input-money': true,
                      'has-error':
                        item.validate &&
                        item.validate.filter(
                          (t) => t.field === 'nettItemSum' && t.fieldValue !== 0
                        ).length > 0,
                    }"
                  >
                    <template #addonLeft>
                      <div class="currency">$</div>
                    </template>
                  </base-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Production Cost" min-width="130">
              <template #header>
                <div style="color: #eb6100">Production Cost</div>
              </template>
              <template #default="scope">
                <div
                  style="display: flex"
                  v-if="scope.row.category !== 'Bus Shelter'"
                >
                  <div class="input-currency-noarea">
                    <base-input
                      v-model="scope.row.unitProductionCost"
                      :disabled="true"
                      @blur="
                        ContractSplitMediaValidate(index, 'unitProductionCost')
                      "
                      @change="changeUnitProdCostEvent(index, true)"
                      class="input-money base-input"
                      :class="{
                        'has-error':
                          item.validate &&
                          item.validate.filter(
                            (t) =>
                              t.field === 'unitProductionCost' &&
                              t.fieldValue !== 0
                          ).length > 0,
                      }"
                    >
                      <template #addonLeft>
                        <div class="currency">$</div>
                      </template>
                    </base-input>
                  </div>
                  <div style="padding: 5px; font-size: 18px">
                    <productionsplit
                      :SplitDetailId="scope.row.id"
                      :SplitMediaId="scope.row.splitMediaId"
                      :disabled="useContractInfo.unitProdCostDisabled"
                      :mode="!disabled ? 'edit' : 'view'"
                      :mediaName="scope.row.mediaName"
                      :seqNo="index"
                      :is-visible="ProdSplitVisibleIndex == index"
                      :production-cost-splits="
                        scope.row.productionSplit?.prod_cost_split ?? []
                      "
                      :custom-fields="scope.row.productionSplit?.custom_fields"
                      :total-cost="scope.row.productionSplit?.totalCost ?? 0"
                      @show="
                        (value, disable) =>
                          UpdatePopoverIndex(index, value, disable)
                      "
                      @close="
                        (value, disable) =>
                          UpdatePopoverIndex(index, value, disable)
                      "
                      @save="SaveProductionCostSplit"
                      :before-show="beforeShowPopover"
                      ref="popoverRef1"
                    />
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="Special Commission (Media)" min-width="160">
              <template #header>
                <div>Special Commission (Media)</div>
              </template>
              <template #default="scope">
                <div class="input-currency-noarea">
                  <base-input
                    v-if="useContractInfo.isMedia"
                    v-model="scope.row.commissionMediaCost"
                    :disabled="disabled || !useContractInfo.isMedia"
                    @change="changeCommissionMediaCost(index)"
                    v-on:input="checkInput"
                    class="base-input"
                    :class="{
                      'input-money': true,
                    }"
                  >
                    <template #addonLeft>
                      <div class="currency">$</div>
                    </template>
                  </base-input>
                  <base-input v-if="!useContractInfo.isMedia" disabled>
                  </base-input>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="Special Commission (Production)"
              min-width="180"
            >
              <template #header>
                <div>Special Commission (Production)</div>
              </template>
              <template #default="scope">
                <div class="input-currency-noarea">
                  <base-input
                    v-if="useContractInfo.isProduction"
                    v-model="scope.row.commissionProductionCost"
                    :disabled="disabled || !useContractInfo.isProduction"
                    @change="changeCommissionProductionCost(index)"
                    v-on:input="checkInput"
                    class="base-input"
                    :class="{
                      'input-money': true,
                    }"
                  >
                    <template #addonLeft>
                      <div class="currency">$</div>
                    </template>
                  </base-input>
                  <base-input v-if="!useContractInfo.isProduction" disabled>
                  </base-input>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="totalProductionCost"
              label="Total Prod. Cost"
              min-width="100"
              v-if="false"
              :formatter="formatterCellMoney"
            >
              <template #header>
                <div style="color: #eb6100">Total Prod. Cost</div>
              </template>
              <template #default="scope">
                <div
                  v-if="scope.row.category === 'Bus Shelter'"
                  class="input-currency-noarea"
                >
                  <base-input
                    v-model="scope.row.totalProductionCost"
                    :disabled="
                      disabled ||
                      useContractInfo.Contract.contractType === 'media'
                    "
                    @blur="
                      ContractSplitMediaValidate(index, 'totalProductionCost')
                    "
                    @change="changeTotalProductionCost(index)"
                    class="input-money base-input"
                    :class="{
                      'has-error':
                        item.validate &&
                        item.validate.filter(
                          (t) =>
                            t.field === 'totalProductionCost' &&
                            t.fieldValue !== 0
                        ).length > 0,
                    }"
                  >
                    <template #addonLeft>
                      <div class="currency">$</div>
                    </template>
                  </base-input>
                </div>
                <div v-else class="total-prod-cost">
                  <span>
                    {{
                      formatterCellMoney('', '', scope.row.totalProductionCost)
                    }}</span
                  >
                  <div
                    class="btn-groups text-right"
                    style="flex-grow: 1"
                    v-if="
                      isShowRoundButtons(
                        scope.row.totalProductionCost,
                        scope.$index
                      )
                    "
                  >
                    <el-button
                      link
                      class="icon-button"
                      @click="RoundNumber('up', scope.row, index)"
                      ><el-icon class="matrix-icon">
                        <CirclePlusFilled /> </el-icon
                    ></el-button>
                    <el-button
                      link
                      class="icon-button"
                      @click="RoundNumber('down', scope.row, index)"
                      ><el-icon class="matrix-icon"> <RemoveFilled /> </el-icon
                    ></el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="mediaTotalInternalSplit"
              label="Media Total (Int.Split)"
              min-width="130"
              v-if="false"
            >
              <template #default="scope">
                <div class="input-currency-noarea">
                  <base-input
                    v-model="scope.row.mediaTotalInternalSplit"
                    :disabled="
                      disabled || useContractInfo.mediaTotalIntlDisabled
                    "
                    @blur="
                      ContractSplitMediaValidate(
                        index,
                        'mediaTotalInternalSplit'
                      )
                    "
                    @change="changeMediaTotalIntlSplit(index)"
                    class="input-money base-input"
                    :class="{
                      'has-error':
                        item.validate &&
                        item.validate.filter(
                          (t) =>
                            t.field === 'mediaTotalInternalSplit' &&
                            t.fieldValue !== 0
                        ).length > 0,
                    }"
                  >
                    <template #addonLeft>
                      <div class="currency">$</div>
                    </template>
                  </base-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="productionTotalInternalSplit"
              label="Prod.Total (Int.Split)"
              min-width="120"
              v-if="false"
            >
              <template #default="scope">
                <div class="input-currency-noarea">
                  <base-input
                    v-model="scope.row.productionTotalInternalSplit"
                    :disabled="
                      disabled || useContractInfo.prodTotalIntlDisabled
                    "
                    @blur="
                      ContractSplitMediaValidate(
                        index,
                        'productionTotalInternalSplit'
                      )
                    "
                    @change="changeProductionTotalIntlSplit(index)"
                    class="input-money base-input"
                    :class="{
                      'has-error':
                        item.validate &&
                        item.validate.filter(
                          (t) =>
                            t.field === 'productionTotalInternalSplit' &&
                            t.fieldValue !== 0
                        ).length > 0,
                    }"
                  >
                    <template #addonLeft>
                      <div class="currency">$</div>
                    </template>
                  </base-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="serviceFee"
              label="Service Fee"
              min-width="120"
              v-if="false"
            >
              <template #default="scope">
                <div class="input-currency-noarea">
                  <base-input
                    v-model="scope.row.serviceFee"
                    :disabled="disabled || useContractInfo.serviceFeeDisabled"
                    @blur="ContractSplitMediaValidate(index, 'serviceFee')"
                    @change="changeServiceFee(index)"
                    class="input-money base-input"
                    :class="{
                      'has-error':
                        item.validate &&
                        item.validate.filter(
                          (t) => t.field === 'serviceFee' && t.fieldValue !== 0
                        ).length > 0,
                    }"
                  >
                    <template #addonLeft>
                      <div class="currency">$</div>
                    </template>
                  </base-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column min-width="40" label="Com" v-if="false">
              <template #default="scope">
                <div style="display: flex">
                  <!-- <i class="el-icon-time" /> -->
                  <specialcommission
                    :SplitDetailId="scope.row.id"
                    :SplitMediaId="scope.row.splitMediaId"
                    :disabled="useContractInfo.comDisabled"
                    :mode="!disabled ? 'edit' : 'view'"
                    :seq-no="index"
                    :media-name="scope.row.mediaName"
                    @save="SaveCommission"
                    @show="(value) => (isSpeicalCommissionVisible = value)"
                    @close="(value) => (isSpeicalCommissionVisible = value)"
                    :before-show="beforeShowPopover"
                    ref="popoverRef2"
                    v-click-outside="CommissionOutsideClick"
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-card>
      <div class="row">
        <div class="col-sm-3">
          <table style="width: 100%">
            <tr>
              <th
                colspan="2"
                style="
                  text-align: center;
                  background-color: #f5f6fa;
                  border: solid 1px #f5f6fa;
                "
              >
                Contract Amount
              </th>
            </tr>
            <tr style="border: solid 1px #e3e3e3">
              <td style="width: 40%; text-align: right">Media:</td>
              <td style="width: 55%; text-align: left">
                <span style="line-height: 29px">
                  HK{{ formatter_money(ContractSplit.contractMediaAmount) }}
                </span>
              </td>
            </tr>
            <tr style="border: solid 1px #e3e3e3">
              <td style="width: 45%; text-align: right">
                <span>Production: </span>
              </td>
              <td style="width: 55%; text-align: left">
                <span style="line-height: 29px"
                  >HK{{
                    formatter_money(ContractSplit.contractProductionAmount)
                  }}</span
                >
              </td>
            </tr>
            <tr style="border: solid 1px #e3e3e3">
              <td style="width: 45%; text-align: right">
                <span>Total: </span>
              </td>
              <td style="width: 55%; text-align: left">
                <span style="line-height: 29px"
                  >HK{{
                    formatter_money(ContractSplit.contractTotalAmount)
                  }}</span
                >
              </td>
            </tr>
          </table>
        </div>

        <div class="col-sm-3">
          <table style="width: 100%">
            <tr>
              <th
                colspan="2"
                style="
                  text-align: center;
                  background-color: rgba(62, 161, 236, 0.2);
                  border: solid 1px rgba(62, 161, 236, 0.2);
                "
              >
                Gross Media
              </th>
            </tr>
            <tr style="border: solid 1px #e3e3e3">
              <td style="width: 40%; text-align: right">Non-Bonus:</td>
              <td style="width: 55%; text-align: left">
                <span style="line-height: 29px"
                  >HK{{ formatter_money(ContractSplit.grossMediaTotal) }}</span
                >
              </td>
            </tr>
            <tr style="border: solid 1px #e3e3e3">
              <td style="width: 45%; text-align: right">
                <span>Bonus: </span>
              </td>
              <td style="width: 55%; text-align: left">
                <span style="line-height: 29px"
                  >HK{{ formatter_money(ContractSplit.mediaBonusTotal) }}</span
                >
              </td>
            </tr>
          </table>
        </div>
        <div class="col-sm-3">
          <table style="width: 100%">
            <tr>
              <th
                colspan="2"
                style="
                  text-align: center;
                  background-color: rgba(235, 97, 0, 0.2);
                  border: solid 1px rgba(235, 97, 0, 0.2);
                "
              >
                Production
              </th>
            </tr>
            <tr style="border: solid 1px #e3e3e3">
              <td style="width: 40%; text-align: right">Non-Bonus:</td>
              <td style="width: 55%; text-align: left">
                <span style="line-height: 29px"
                  >HK{{ formatter_money(ContractSplit.productionTotal) }}</span
                >
              </td>
            </tr>
            <tr style="border: solid 1px #e3e3e3">
              <td style="width: 45%; text-align: right">
                <span>Bonus: </span>
              </td>
              <td style="width: 55%; text-align: left">
                <span style="line-height: 29px"
                  >HK{{
                    formatter_money(ContractSplit.productionBonusTotal)
                  }}</span
                >
              </td>
            </tr>
          </table>
        </div>
        <div class="col-sm-3">
          <table style="width: 100%">
            <tr>
              <th
                colspan="2"
                style="
                  text-align: center;
                  background-color: #f5f6fa;
                  border: solid 1px #f5f6fa;
                "
              >
                Special Commission
              </th>
            </tr>
            <tr style="border: solid 1px #e3e3e3">
              <td style="width: 40%; text-align: right">Media:</td>
              <td style="width: 55%; text-align: left">
                <span style="line-height: 29px" v-if="useContractInfo.isMedia">
                  {{
                    formatter_commission(ContractSplit.specialComMediaAmount)
                  }}</span
                >
                <span style="line-height: 29px" v-else>- </span>
              </td>
            </tr>
            <tr style="border: solid 1px #e3e3e3">
              <td style="width: 45%; text-align: right">
                <span>Production: </span>
              </td>
              <td style="width: 55%; text-align: left">
                <span
                  style="line-height: 29px"
                  v-if="useContractInfo.isProduction"
                >
                  {{
                    formatter_commission(
                      ContractSplit.specialComProductionAmount
                    )
                  }}
                </span>
                <span style="line-height: 29px" v-else>- </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </el-card>

    <el-card>
      <div class="row" style="text-align: center; justify-content: center">
        <div class="col-sm-5">
          <table class="internal-split">
            <tr>
              <td colspan="3">
                <div class="row" style="margin: 0px">
                  <span
                    style="line-height: 32px; color: #754f34; font-size: 12px"
                    >Media Nett</span
                  >
                </div>
                <div class="row" style="margin: 0px">
                  <div class="col-sm-6" style="padding: 0">
                    <base-input
                      class="input-money"
                      v-model="ContractSplit.mediaNett"
                      :disabled="
                        disabled || useContractInfo.nettItemSumDisabled
                      "
                      @blur="ContractSplitValidate('mediaNett')"
                      @change="changeMediaNett"
                    >
                      <template #addonLeft>
                        <div class="currency">HK$</div>
                      </template>
                    </base-input>
                  </div>
                  <div
                    class="col-sm-6"
                    style="text-align: right; padding-right: 0px"
                  >
                    <base-button
                      style="margin-top: 0px; margin-bottom: 0px"
                      type="primary"
                      :disabled="disabled"
                      @click="Calculate"
                      >Calculate</base-button
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <div class="row" style="margin: 0px">
                  <span
                    class="col-sm-4"
                    style="
                      line-height: 32px;
                      text-align: left;
                      padding-left: 0px;
                      color: #754f34;
                      font-size: 12px;
                    "
                    >Production Cost</span
                  >
                  <span
                    class="col-sm-8"
                    style="
                      line-height: 32px;
                      text-align: left;
                      color: #754f34;
                      font-size: 12px;
                    "
                    >Please Select</span
                  >
                </div>
                <div class="row" style="margin: 0px">
                  <div
                    class="col-sm-4 RectangleNoWidth"
                    style="background-color: #fff; border: 0px"
                  >
                    HK{{ formatter_money(ContractSplit.piCost) }}
                  </div>
                  <div class="col-sm-8" style="padding-right: 0px">
                    <base-input
                      :class="{
                        'has-error':
                          ContractSplit.validate &&
                          validation.isError(
                            ContractSplit.validate,
                            'productionCostType'
                          ),
                      }"
                    >
                      <el-select
                        v-model="ContractSplit.productionCostType"
                        class="select-primary"
                        size="large"
                        filterable
                        placeholder="Production Cost Type"
                        :disabled="disabled || (ContractSplit.piCost || 0) <= 0"
                      >
                        <el-option value="" label="-">-</el-option>
                        <el-option
                          v-for="item in useInternalSplit.ProductionCostOptions"
                          :key="item"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="false">
              <td colspan="3">
                <div class="row" style="margin: 0px">
                  <span
                    class="col-sm-4"
                    style="
                      line-height: 32px;
                      text-align: left;
                      padding-left: 0px;
                      color: #754f34;
                      font-size: 12px;
                    "
                    >Sales Service Fee</span
                  >
                  <span
                    class="col-sm-8"
                    style="
                      line-height: 32px;
                      text-align: left;
                      color: #754f34;
                      font-size: 12px;
                    "
                    >Please Select</span
                  >
                </div>
                <div class="row" style="margin: 0px">
                  <div class="col-sm-4 service-fee" style="padding: 0">
                    <base-input
                      v-model="ContractSplit.salesServiceFee"
                      :disabled="disabled || useContractInfo.serviceFeeDisabled"
                      class="input-money"
                      @blur="ContractSplitValidate('salesServiceFee')"
                      @change="changeSalesServiceFee"
                    >
                      <template #addonLeft>
                        <div class="currency">HK$</div>
                      </template>
                    </base-input>
                  </div>
                  <div class="col-sm-3" style="padding-right: 0px">
                    <base-input
                      style="background-color: #f5f5f5"
                      :class="{
                        'has-error':
                          ContractSplit.validate &&
                          validation.isError(
                            ContractSplit.validate,
                            'salesServiceType'
                          ),
                      }"
                    >
                      <el-select
                        v-model="ContractSplit.salesServiceType"
                        class="select-primary"
                        size="large"
                        filterable
                        :disabled="disabled || bServiceTypeDisabled"
                      >
                        <el-option value="" label="-"></el-option>
                        <el-option
                          v-for="item in useInternalSplit.SalesServiceTypeOptions"
                          :key="item"
                          :value="item.value"
                          :label="item.label"
                        ></el-option>
                      </el-select>
                    </base-input>
                  </div>
                  <div class="col-sm-5" style="padding-right: 0px">
                    <base-input
                      v-model="ContractSplit.salesServiceOther"
                      :disabled="disabled || bServiceTypeDisabled"
                    >
                    </base-input>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="false">
              <td colspan="3">
                <div class="row" style="margin: 0px">
                  <span
                    class="col-sm-4"
                    style="
                      line-height: 32px;
                      text-align: left;
                      padding-left: 0px;
                      color: #754f34;
                      font-size: 12px;
                    "
                    >Additional Production (Reserved)</span
                  >
                  <span
                    class="col-sm-8"
                    style="
                      line-height: 32px;
                      text-align: left;
                      color: #754f34;
                      font-size: 12px;
                    "
                    >End Date</span
                  >
                </div>
                <div class="row" style="margin: 0px">
                  <div
                    class="col-sm-4"
                    style="padding-left: 0; padding-right: 0"
                  >
                    <base-input
                      v-model="ContractSplit.additionalProduction"
                      :disabled="
                        disabled || useContractInfo.unitProdCostDisabled
                      "
                      @blur="ContractSplitValidate('additionalProduction')"
                      @change="changeAdditionalProduction"
                      class="input-money"
                    >
                      <template #addonLeft>
                        <div class="currency">HK$</div>
                      </template></base-input
                    >
                  </div>
                  <div class="col-sm-8" style="padding-right: 0px">
                    <base-input>
                      <el-date-picker
                        v-model="ContractSplit.additionalProductionEndDate"
                        type="date"
                        style="border: 0px"
                        format="DD/MM/YYYY"
                        value-format="YYYY-MM-DD"
                        :disabled="disabled || bAdditionalDisabled"
                        class="form-group date"
                        :class="{
                          'has-error':
                            ContractSplit.validate &&
                            validation.isError(
                              ContractSplit.validate,
                              'additionalProductionEndDate'
                            ),
                        }"
                      >
                      </el-date-picker
                    ></base-input>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="bEnableSpecialDiscount">
              <td colspan="3">
                <div class="row" style="margin: 0px">
                  <span
                    class="col-sm-4"
                    style="
                      line-height: 32px;
                      text-align: left;
                      padding-left: 0px;
                      color: #754f34;
                      font-size: 12px;
                    "
                    >Special Discount</span
                  >
                </div>
                <div class="row" style="margin: 0px">
                  <div
                    class="col-sm-4"
                    style="padding-left: 0; padding-right: 0"
                  >
                    <base-input
                      v-model="ContractSplit.specialDiscountAmount"
                      :disabled="
                        disabled || useContractInfo.specialDiscountDisabled
                      "
                      @blur="ContractSplitValidate('specialDiscountAmount')"
                      @change="changeSpecialDiscountAmount"
                      class="input-money"
                    >
                      <template #addonLeft>
                        <div class="currency">HK$</div>
                      </template></base-input
                    >
                  </div>
                  <div class="col-sm-8" style="padding-right: 0px">
                    <base-input
                      :class="{
                        'has-error':
                          ContractSplit?.validate &&
                          validation.isError(
                            ContractSplit.validate,
                            'specialDiscountDesc'
                          ),
                      }"
                      :disabled="
                        disabled || useContractInfo.specialDiscountDisabled
                      "
                      v-model="ContractSplit.specialDiscountDesc"
                    >
                    </base-input>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="1">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      padding-left: 0px;
                      color: #754f34;
                      font-size: 12px;
                    "
                  >
                    A.C.(Y/N)
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="background-color: rgb(255, 255, 255); border: 0px"
                  >
                    {{ formatterYesOrNo(ContractSplit.isAgency) }}
                  </div>
                </div>
              </td>
              <td colspan="1">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      color: #754f34;
                      font-size: 12px;
                    "
                  >
                    New Client
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="background-color: rgb(255, 255, 255); border: 0px"
                  >
                    {{ formatterYesOrNo(ContractSplit.isNewClient) }}
                  </div>
                </div>
              </td>
              <td colspan="1">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      color: #754f34;
                      font-size: 12px;
                    "
                  >
                    Charity
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="background-color: rgb(255, 255, 255); border: 0px"
                  >
                    {{ formatterYesOrNo(ContractSplit.isCharity) }}
                  </div>
                </div>
              </td>
            </tr>
            <!-- FFFFFFASD -->
          </table>
        </div>
        <div class="col-sm-5">
          <table class="internal-split">
            <!-- Gross Media Total (w/o Bonus) -->
            <tr>
              <td colspan="4">
                <div class="row">
                  <div class="col-sm-12">
                    <div
                      style="
                        line-height: 32px;
                        text-align: left;
                        padding-left: 0px;
                        color: #754f34;
                        font-size: 12px;
                      "
                    >
                      Gross Media Total (w/o Bonus)
                    </div>
                  </div>
                  <div class="col-sm-12" style="text-align: left">
                    <div
                      class="RectangleNoWidth"
                      style="background-color: rgb(255, 255, 255); border: 0px"
                    >
                      HK{{ formatter_money(ContractSplit.grossMediaTotal) }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <!-- Gross Media Total (W/Bonus) -->
            <tr>
              <td colspan="4">
                <div class="row">
                  <div class="col-sm-12">
                    <div
                      style="
                        line-height: 32px;
                        text-align: left;
                        padding-left: 0px;
                        color: #754f34;
                        font-size: 12px;
                      "
                    >
                      Gross Media Total (W/Bonus)
                    </div>
                  </div>
                  <div class="col-sm-12" style="text-align: left">
                    <div
                      class="RectangleNoWidth"
                      style="background-color: rgb(255, 255, 255); border: 0px"
                    >
                      HK{{
                        formatter_money(ContractSplit.grossMediaTotalWithBonus)
                      }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <!-- Discount Rate Before Bonus -->
            <tr>
              <td style="width: 40%">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      padding-left: 0px;
                      color: #754f34;
                      font-size: 12px;
                    "
                  >
                    Discount Rate Before Bonus
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="background-color: rgb(255, 255, 255); border: 0px"
                  >
                    HK{{
                      formatter_money(ContractSplit.discountTotalWithBonus)
                    }}
                  </div>
                </div>
              </td>
              <td>
                <div style="">
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    -
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="
                      background-color: rgb(255, 255, 255);
                      border: 0px;
                      color: #32caad;
                    "
                  >
                    {{
                      formatter_money(ContractSplit.discountRateWithBonus, ' ')
                    }}%
                  </div>
                </div>
              </td>
              <td v-if="false">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      color: #754f34;
                      font-size: 12px;
                    "
                  >
                    SA Internal
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="
                      background-color: rgb(255, 255, 255);
                      border: 0px;
                      color: #32caad;
                    "
                  >
                    HK{{
                      formatter_money(ContractSplit.discountTotalWithBonusSA)
                    }}
                  </div>
                </div>
              </td>
              <td v-if="false">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    -
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="
                      background-color: rgb(255, 255, 255);
                      border: 0px;
                      color: #32caad;
                    "
                  >
                    {{ ContractSplit.discountRateWithBonusSA }}%
                  </div>
                </div>
              </td>
            </tr>
            <!-- Discount Rate -->
            <tr>
              <td>
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      padding-left: 0px;
                      color: #754f34;
                      font-size: 12px;
                    "
                  >
                    Discount Rate
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="background-color: rgb(255, 255, 255); border: 0px"
                  >
                    HK{{ formatter_money(ContractSplit.discountTotal) }}
                  </div>
                </div>
              </td>
              <td>
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    -
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="
                      background-color: rgb(255, 255, 255);
                      border: 0px;
                      color: #b60005;
                    "
                  >
                    {{ formatter_money(ContractSplit.discountRate, ' ') }}%
                  </div>
                </div>
              </td>
              <td v-if="false">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      color: #754f34;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    -
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="
                      background-color: rgb(255, 255, 255);
                      border: 0px;
                      color: #b60005;
                    "
                  >
                    HK{{ formatter_money(ContractSplit.discountTotalSA) }}
                  </div>
                </div>
              </td>
              <td v-if="false">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    -
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="
                      background-color: rgb(255, 255, 255);
                      border: 0px;
                      color: #b60005;
                    "
                  >
                    {{ ContractSplit.discountRateSA }}%
                  </div>
                </div>
              </td>
            </tr>
            <!-- AC -->
            <tr>
              <td colspan="1">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      padding-left: 0px;
                      color: #754f34;
                      font-size: 12px;
                    "
                  >
                    A.C.
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="background-color: rgb(255, 255, 255); border: 0px"
                  >
                    HK{{ formatter_money(ContractSplit.agencyDiscountTotal) }}
                  </div>
                </div>
              </td>
              <td colspan="1">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      font-size: 12px;
                      color: white;
                    "
                  >
                    -
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="
                      background-color: rgb(255, 255, 255);
                      border: 0px;
                      color: #4aa3f9;
                    "
                  >
                    {{
                      formatter_money(ContractSplit.agencyDiscountRate, ' ')
                    }}%
                  </div>
                </div>
              </td>
              <td colspan="2" v-if="false"></td>
            </tr>
            <!-- Media Nett -->
            <tr>
              <td colspan="4">
                <div>
                  <div
                    style="
                      line-height: 32px;
                      text-align: left;
                      padding-left: 0px;
                      color: rgb(117, 79, 52);
                      font-size: 12px;
                    "
                  >
                    Media Nett
                  </div>
                  <div
                    class="RectangleNoWidth"
                    style="background-color: rgb(255, 255, 255); border: 0px"
                  >
                    HK{{ formatter_money(ContractSplit.mediaNett) }}
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { initCustomFormatter, ref, watch, onUpdated } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import {
  CaretBottom,
  CirclePlusFilled,
  RemoveFilled,
} from '@element-plus/icons-vue';
import baseCheckbox from '@/components/newUI/Inputs/BaseCheckbox';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import productionsplit from './productionsplit.vue';
import specialcommission from './specialcommission.vue';
import mediaperiod from './mediaPeriod.vue';
import append from '../MediaItem/append.vue';
import dateJs from '@/assets/js/date.js';
import {
  formatter_money,
  formatterCellMoney,
  formatterRate,
} from '@/assets/js/formatter.js';
import validation from '@/assets/js/validation.js';
import { storeToRefs } from 'pinia';
import { useInternalSplitStore } from '@/store/internalsplit.js';
import { useContractInfoStore } from '@/store/contractinfo';
import { useContractStore } from '@/store/contract';
import { useOrderStore } from '@/store/order.js';
import { useAuthorityStore } from '@/store/authority';
import { ClickOutside as vClickOutside } from '@/assets/js/directive';
import contractnet from '../../../network/contractnet';
import mediaJs from '../js/Media.js';

const MediaObj = require('../js/Media.js');
const numberJs = require('@/assets/js/numberjs.js');
const convertDecimal = require('@/assets/js/convert.js').convertDecimal;

const authorityStore = useAuthorityStore();
const useOrder = useOrderStore();
const useInternalSplit = useInternalSplitStore();
const useContract = useContractStore();
const useContractInfo = useContractInfoStore();
const { bEnableSpecialDiscount } = storeToRefs(useContract);
const { ContractSplit, ContractSplitMedias } = storeToRefs(useInternalSplit);
const { CostTypeList } = storeToRefs(useInternalSplit);

const bServiceTypeDisabled = ref(null);
const bAdditionalDisabled = ref(null);
const isProdSplitVisible = ref(false);
const ProdSplitVisibleIndex = ref(-1);
const isSpeicalCommissionVisible = ref(false);
const popoverRef1 = ref();
const popoverRef2 = ref();
const ProductionCostSplit = ref();
//浏览器宽度的80%,Append宽度设置
const widthSpan = window.innerWidth * 0.8 + 'px';
watch(
  () => ContractSplit.value.salesServiceFee,
  (newValue) => {
    if (bServiceTypeDisabled.value === null) {
      bServiceTypeDisabled.value = convertDecimal(newValue || 0) <= 0;
    }
  }
);

watch(
  () => ContractSplit.value.additionalProduction,
  (newValue) => {
    if (bAdditionalDisabled.value === null) {
      bAdditionalDisabled.value = convertDecimal(newValue || 0) <= 0;
    }
  }
);
//在组件数据更新后但在重绘前调用
onUpdated(() => {
  if ((useInternalSplit.ContractSplit.id || 0) === 0) {
    InitProductionCost();
  }
});

const props = defineProps({
  disabled: Boolean,
});

//输入必须为正数
const checkInput = (event) => {
  let input = event.target.value;
  if ((input && isNaN(input)) || parseFloat(input) < 0) {
    // this.$message.error('输入必须为正整数');
    event.target.value = '';
  }
};

const getLocationDescriptionValue = (index) => {
  var locationDescription = JSON.parse(
    ContractSplitMedias.value[index].mediaSnap || '{}'
  )?.locationDescription;

  if (locationDescription) {
    return JSON.parse(locationDescription)?.en;
  }
  return '';
};
// event: 计算天数,Gross Item Sum
const changeGrossItemSum = (index) => {
  const media = ContractSplitMedias.value[index];

  var MediaPlan = JSON.parse(media?.mediaPlan || '{}');
  const loading = parseFloat(media.loading);
  // Gross Item Sum = 原价 * (1+loading) / 7 * QTY * Days
  const Obj = {
    category: media.category,
    grossRate: media.grossRate,
    unitQty: media.unitQty,
    noOfDays: media.noOfDays,
    quantity: media.quantity,
    loading,
    unitRate: media.unitRate,
    rateOption: MediaPlan?.rateOption,
    inventoryDeduction: MediaPlan?.inventoryDeduction,
    planName: MediaPlan?.planName,
  };
  if (Obj.rateOption.indexOf('Week') >= 0) {
    media.grossItemSum = Math.round(
      (Obj.grossRate / media.unitQty / 7) * Obj.quantity * Obj.noOfDays,
      0
    ).toFixed(2);
  } else if (Obj.rateOption.indexOf('Month') >= 0) {
    var dayjs = require('dayjs');
    var startDay = dayjs(media.dates[0]);
    var endDay = dayjs(media.dates[1]);
    var bMonth =
      new Date(media.dates[0]).getDate() == 1 &&
      new Date(media.dates[1]).getDate() == endDay.daysInMonth(); //足月

    // 足月a计算,不足月b计算
    if (bMonth) {
      var diffMonth = Math.round(endDay.diff(startDay, 'month', true), 0);
      media.grossItemSum = Math.round(
        (Obj.grossRate / media.unitQty) * diffMonth * Obj.quantity,
        0
      ).toFixed(2);
    } else {
      media.grossItemSum = Math.round(
        (((Obj.grossRate / media.unitQty) * 12) / 365) *
          Obj.quantity *
          Obj.noOfDays,
        0
      ).toFixed(2);
    }
  } else if (Obj.rateOption.indexOf('Year') >= 0) {
    media.grossItemSum = Math.round(
      (Obj.grossRate / media.unitQty / 365) * Obj.quantity * Obj.noOfDays,
      0
    ).toFixed(2);
  }
  // media.grossItemSum = MediaObj.CalcGrossItemSum(Obj);

  // 更新媒体费用
  useInternalSplit.totalMediaAmount();
};
// 更新制作费用单价
const changeUnitProdCostEvent = async (index, Ischange, CostTypeListInit) => {
  const Media = ContractSplitMedias.value[index];

  Media.unitProductionCost =
    Math.round((Media.unitProductionCost || 0) * 100, 2) / 100;

  Media.totalProductionCost = Media.unitProductionCost * 1;
  Media.productionTotalInternalSplit = Media.totalProductionCost || 0;
  //是否直接更改ProductionSplit
  if (Ischange) {
    // 初始化ProductionCostSplit信息，并且更新数据

    var production_cost = ContractSplitMedias.value[index];

    production_cost.prod_cost_split = useInternalSplit.ProductionCostTypes.sort(
      (a, b) => a.sort - b.sort
    );
    production_cost.prod_cost_split[0].amount = Media.totalProductionCost;
    production_cost.prod_cost_split[0].qty = 1;
    production_cost.prod_cost_split[0].amountSum = Media.totalProductionCost;
    production_cost.totalCost = Media.totalProductionCost;
    production_cost.productionCostSplit = JSON.stringify(
      production_cost.prod_cost_split
    );

    useInternalSplit.ProductionSplit.totalCost = Media.totalProductionCost;
    //是否为初始化制作费数据
    if (CostTypeListInit != true) {
      //切换当前编辑的媒体
      useInternalSplit.getProductionSplit(Media.splitMediaId);
      CostTypeList.value.forEach((item, index) => {
        if (item.code == 'pidCost') {
          item.amount = Media.totalProductionCost;
          item.qty = 1;
        } else {
          item.amount = 0;
          item.qty = 0;
        }
      });
    }
    useInternalSplit.UpdateProductionSplit();
  }

  // 更新制作费摘要
  useInternalSplit.totalProductionAmount();

  changeProductionTotalIntlSplit(index);

  if (convertDecimal(ContractSplit.value.piCost || 0) === 0) {
    ContractSplit.value.productionCostType = '';
  }
};

const changeTotalProductionCost = (index) => {
  const Media = ContractSplitMedias.value[index];

  Media.productionTotalInternalSplit = Media.totalProductionCost || 0;

  // 更新制作费摘要
  useInternalSplit.totalProductionAmount();

  changeProductionTotalIntlSplit(index);

  if (convertDecimal(ContractSplit.value.piCost || 0) === 0) {
    ContractSplit.value.productionCostType = '';
  }
};
const changeCommissionProductionCost = (index) => {
  const Media = ContractSplitMedias.value[index];

  Media.commissionProductionCost =
    Math.round((Media.commissionProductionCost || 0) * 100, 2) / 100;

  // 更新制作费摘要
  useInternalSplit.totalCommissionAmount();
};
const changeCommissionMediaCost = (index) => {
  const Media = ContractSplitMedias.value[index];

  Media.commissionMediaCost =
    Math.round((Media.commissionMediaCost || 0) * 100, 2) / 100;

  // 更新制作费摘要
  useInternalSplit.totalCommissionAmount();
};

// 更新媒体总价拆分
const changeMediaTotalIntlSplit = async (index) => {
  const Media = ContractSplitMedias.value[index];

  const mediaTotalInternalSplit =
    parseFloat(Media.mediaTotalInternalSplit) || 0;
  const nettItemSum = parseFloat(Media.nettItemSum) || 0;
  const totalProductionCost = parseFloat(Media.totalProductionCost) || 0;

  Media.productionTotalInternalSplit = convertDecimal(
    nettItemSum + totalProductionCost - mediaTotalInternalSplit
  );

  useInternalSplit.totalMediaAmount();

  useInternalSplit.totalContractAmount();
};

// 更新媒体制作总价拆分
const changeProductionTotalIntlSplit = async (index) => {
  const Media = ContractSplitMedias.value[index];

  const productionTotalInternalSplit =
    parseFloat(Media.productionTotalInternalSplit) || 0;

  Media.mediaTotalInternalSplit = convertDecimal(
    parseFloat(Media.nettItemSum) +
      parseFloat(Media.totalProductionCost) -
      productionTotalInternalSplit
  );

  useInternalSplit.totalMediaAmount();

  useInternalSplit.totalContractAmount();
};

// 更新媒体服务费
const changeServiceFee = async (index) => {};

const changeSpecialDiscountAmount = async () => {
  ContractSplit.value.specialDiscountAmount =
    Math.round((ContractSplit.value.specialDiscountAmount || 0) * 100, 2) / 100;
  if (ContractSplit.value.specialDiscountAmount == 0) {
    ContractSplit.value.specialDiscountDesc = '';
  }
  useInternalSplit.totalContractAmount();
};

// event: 更新日期,计算天数和Gross Item Sum
const changePeriod = (index) => {
  const media = ContractSplitMedias.value[index];

  var Days = 0;
  if ((media.dates || null) !== null) {
    Days = dateJs.DateDiff(media.dates[0], media.dates[1]) + 1;
  }

  media.startDate = media.dates?.[0] || null;
  media.endDate = media.dates?.[1] || null;

  media.noOfDays = Days;

  changeGrossItemSum(index);
};

// 更新Loading
const changeLoading = async (index) => {
  changeGrossItemSum(index);
};

// change: 媒体实付价格
const changeNettItemSum = async (index) => {
  const splitMedia = ContractSplitMedias.value[index];

  splitMedia.mediaTotalInternalSplit = parseFloat(splitMedia.nettItemSum) || 0;
  // changeMediaTotalIntlSplit(index);
  ContractSplit.value.mediaNett = 0;
  ContractSplitMedias.value.map(
    (t) => (ContractSplit.value.mediaNett += parseFloat(t.nettItemSum))
  );

  splitMedia.nettItemSum = Math.round(splitMedia.nettItemSum * 100, 2) / 100;

  changeMediaNett();
};

// change: 更新Media Nett
const changeMediaNett = async () => {
  if (
    !parseFloat(ContractSplit.value.mediaNett) ||
    isNaN(ContractSplit.value.mediaNett)
  ) {
    ContractSplit.value.mediaNett = 0;
  }

  ContractSplit.value.mediaNett =
    Math.round(ContractSplit.value.mediaNett * 100, 2) / 100;
  useInternalSplit.totalMediaAmount();

  useInternalSplit.totalContractAmount();
};

// change: 更新Service Fee
const changeSalesServiceFee = async () => {
  if (convertDecimal(ContractSplit.value.salesServiceFee || '0') === 0) {
    ContractSplit.value.salesServiceType = '';
    ContractSplit.value.salesServiceOther = '';
  }

  bServiceTypeDisabled.value =
    convertDecimal(ContractSplit.value.salesServiceFee || '0') === 0;

  useInternalSplit.totalContractAmount();
};

// change: 更新Additional Production
const changeAdditionalProduction = async () => {
  if (
    convertDecimal(ContractSplit.value.additionalProduction) > 0 &&
    (ContractSplit.value.additionalProductionEndDate || null) === null
  ) {
    ContractSplit.value.additionalProductionEndDate = dateJs.Max(
      ContractSplitMedias.value.map((t) => t.mediaEndDate)
    );
  }

  if (convertDecimal(ContractSplit.value.additionalProduction) <= 0) {
    ContractSplit.value.additionalProductionEndDate = null;
  }

  bAdditionalDisabled.value =
    convertDecimal(ContractSplit.value.additionalProduction) <= 0;

  useInternalSplit.totalContractAmount();
};

// event: 复制媒体
const copyMedia = async (index) => {
  const ModelJs = require('@/models/contractSplitMedia');
  const CopyMedia = ContractSplitMedias.value[index];

  const entity = JSON.parse(JSON.stringify(CopyMedia));
  entity.id = 0;
  entity.splitMediaId = null;
  const Media = ModelJs.ContractSplitMediaEntity(entity);

  ContractSplitMedias.value.push(Media);
  //复制媒体处理制作合同的制作费用复制
  if (useContract.ContractType === 'production') {
    //切换当前编辑
    await useInternalSplit.getProductionSplit(CopyMedia.splitMediaId);
    await useInternalSplit.UpdateProductionSplit();
    var CostTypeList1 = JSON.parse(JSON.stringify(CostTypeList.value));
    //切换当前编辑
    useInternalSplit.getProductionSplit(Media.splitMediaId);
    CostTypeList.value = CostTypeList1;
    await changeUnitProdCostEvent(
      ContractSplitMedias.value.indexOf(Media),
      true,
      true
    );
  }

  //  await  useInternalSplit.UpdateProductionSplit();

  RefreshSplitMediaTotal();
};

// event: 删除媒体
const deletemedia = async (index) => {
  ElMessageBox.confirm('Do you want to delete?', 'Delete Media', {
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    customClass: 'matrix-message-box',
    confirmButtonClass: 'right-confirm-1',
  }).then(async () => {
    useInternalSplit.deleteMedia(index);
  });
};

const ContractSplitMediaValidate = async (index, field) => {
  const splitMedia = ContractSplitMedias.value[index];

  await useInternalSplit.validate('media', index);

  var error = splitMedia.validate.find((t) => t.field === field) || null;
  if (error != null) {
    ElMessage({
      message: error.message,
      type: 'warning',
    });
  }
};

const ContractSplitValidate = async (field) => {
  await useInternalSplit.validate();

  var error =
    ContractSplit.value.validate.find((t) => t.field === field) || null;
  if (error != null) {
    ElMessage({
      message: error.message,
      type: 'warning',
    });
  }
};

// formatter: 格式化佣金
const formatter_commission = (val) => {
  if (convertDecimal(val) === 0) {
    if (
      useContractInfo.isProduction &&
      ContractSplitMedias.value.find(
        (t) =>
          t.commissionProductionCost === 0 || t.commissionProductionCost === '0'
      )
    ) {
      return 'HK' + formatterCellMoney('', '', 0);
    }
    if (
      useContractInfo.isMedia &&
      ContractSplitMedias.value.find(
        (t) => t.commissionMediaCost === 0 || t.commissionMediaCost === '0'
      )
    ) {
      return 'HK' + formatterCellMoney('', '', 0);
    }
    return '-';
  }
  return 'HK' + formatterCellMoney('', '', val);
};

const formatterYesOrNo = (val) => {
  if (val) {
    return 'Y';
  }
  return 'N';
};

// click: Calculate Button
const Calculate = () => {
  if (beforeShowPopover()) {
    useInternalSplit.Calculate();

    RefreshSplitMediaTotal();
  }
};

// 更新分拆摘要
const RefreshSplitMediaTotal = () => {
  useInternalSplit.totalMediaAmount();

  // 更新制作费用
  useInternalSplit.totalProductionAmount();

  // 更新Contract Amount
  useInternalSplit.totalContractAmount();

  useInternalSplit.totalCommissionAmount();
};

const SaveProductionCostSplit = (data) => {
  const SplitMediaId = data.splitMediaId;
  // 更新分拆制作费到媒体
  const Media = ContractSplitMedias.value.find(
    (t) => t.splitMediaId === SplitMediaId
  );

  // 更新数据
  Media.productionSplit = Object.assign(Media.productionSplit, data);
  Media.productionSplit.productionCostSplit = JSON.stringify(
    Media.productionSplit.prod_cost_split
  );
  Media.productionSplit.productionCostSplitValid = JSON.stringify(
    Media.productionSplit.prod_cost_split.filter((t) => t.amountSum > 0)
  );

  Media.unitProductionCost = data.totalCost;

  changeUnitProdCostEvent(ContractSplitMedias.value.indexOf(Media));
};
const SaveCommission = () => {
  useInternalSplit.totalCommissionAmount();
};
// click: regerate
const regenerate = async () => {
  const result = beforeShowPopover();
  if (result) {
    await useInternalSplit.Regenerate();
    await InitProductionCost();
  }
};
//初始化MIA媒体制作费的一些默认值
const InitProductionCost = async () => {
  //制作合同,预设制作费
  if (useContract.ContractType === 'production')
    ContractSplitMedias.value.map((entity, index) => {
      var mediaPlans = JSON.parse(entity.mediaPlan);
      const productionCost1 = isNaN(parseFloat(mediaPlans.productionPrice))
        ? 0
        : parseFloat(mediaPlans.productionPrice);
      const typhoonArrangementCost1 = isNaN(
        parseFloat(mediaPlans.typhoonArrangementCost)
      )
        ? 0
        : parseFloat(mediaPlans.typhoonArrangementCost);
      entity.unitProductionCost = productionCost1;
      //切换当前编辑
      //useInternalSplit.getProductionSplit(entity.splitMediaId);
      entity.productionSplit.prod_cost_split.forEach((item, index) => {
        item.amount = 0;
        item.qty = 0;
        item.amountSum = 0;
        if (item.code === 'pidCost') {
          item.amount = productionCost1;
          item.qty = productionCost1 > 0 ? 1 : 0;
          item.amountSum = parseFloat((item.amount * item.qty).toFixed(2));
        } else if (item.code === 'typhoonArrangement') {
          item.amount = typhoonArrangementCost1;
        }
      });
      entity.productionSplit.totalCost = entity.productionSplit.prod_cost_split
        .map((t) => t.amountSum)
        .reduce((a, b) => a + b);
      entity.productionSplit.productionCostSplit = JSON.stringify(
        entity.productionSplit.prod_cost_split
      );
      entity.productionSplit.productionCostSplitValid = JSON.stringify(
        entity.productionSplit.prod_cost_split.filter((t) => t.amountSum > 0)
      );
      if (entity.productionSplit.totalCost > 0) {
        entity.productionSplit.splitMediaId = entity.splitMediaId;
      }
      changeUnitProdCostEvent(index, true, true);
    });
};

const beforeShowPopover = (popover_is_active) => {
  // 点击的组件当前状态
  if (popover_is_active) {
    return false;
  }

  // 激活中的popover
  if (isProdSplitVisible.value) {
    ElMessage({
      message: 'Please complete previous steps first',
      type: 'warning',
    });
    return false;
  }
  return true;
};

const UpdatePopoverIndex = (index, value, disable) => {
  isProdSplitVisible.value = !disable;

  if (index !== ProdSplitVisibleIndex.value) {
    if (value) {
      ProdSplitVisibleIndex.value = index;
    }
  }

  if (!value && index == ProdSplitVisibleIndex.value) {
    ProdSplitVisibleIndex.value = -1;
    isProdSplitVisible.value = false;
  }
};

const present_prodCostSplit = () => {
  return popoverRef1.value.find((t) => t.isActive());
};

const present_commission = () => {
  return popoverRef2.value.find((t) => t.isActive());
};

const ProdSplitOutsideClick = (e) => {
  // if (
  //   isProdSplitVisible.value &&
  //   !e.target.attributes?.class?.value?.includes('popover-button-icon')
  // ) {
  //   popoverRef1.value.find((t) => t.isActive())?.close();
  // }
};

const CommissionOutsideClick = (e) => {
  if (isSpeicalCommissionVisible.value && props.disabled) {
    popoverRef2.value.find((t) => t.isActive())?.close();
  }
};

const isShowRoundButtons = (value, index) => {
  if (!value) {
    value = 0;
  }
  var item = value.toString().split('.') || [];
  return item.length > 1 && parseFloat(item[1]) > 0;
};
const RoundNumber = (type, item, index) => {
  var value = item.totalProductionCost;
  if (!value) {
    value = 0;
  }

  if (type === 'up') {
    item.totalProductionCost = parseInt(value.toString().split('.')[0]) + 1;
  } else {
    item.totalProductionCost = parseInt(value.toString().split('.')[0]);
  }

  changeTotalProductionCost(index);
};

const getMediaTechinologyValue = (index) => {
  var technology = JSON.parse(
    ContractSplitMedias.value[index].mediaSnap || '{}'
  )?.technology;

  console.log('index', ContractSplitMedias.value, technology);

  if (technology) {
    var technology_name = JSON.parse(technology)?.[0]?.Name;
    if (technology_name) {
      return JSON.parse(technology_name)?.en;
    }
  }
  return '';
};

defineExpose({
  ProductionCostSplitRef: {
    isActive() {
      return isProdSplitVisible.value;
    },
    close() {
      present_prodCostSplit()?.close();
    },
  },
  SpecialCommissionArragementRef: {
    isActive() {
      return isSpeicalCommissionVisible.value;
    },
    close() {
      present_commission()?.close();
    },
  },
});
</script>
<style>
.internal-split .form-control {
  font-size: 0.857rem !important;
}

.internal-split .form-control.RectangleNoWidth {
  text-align: left;
  border-radius: 6px;
  border: solid 0px;
  height: 38px;
}

.icon-button .matrix-icon.disabled {
  color: #9a9a9a !important;
}

.icon-button .matrix-icon {
  color: #53bc9c;
}

.icon-button .matrix-icon:hover {
  opacity: 0.7;
}

.internal-split .form-control:disabled,
.base-input.form-group .form-control:disabled,
.base-input.form-group .el-range-editor.is-disabled {
  border: 1px solid #e3e3e3;
  background-color: #f5f5f5;
}

.internal-split .form-group .el-input.is-disabled .el-input__wrapper {
  box-shadow: 0 0 0 1px #e3e3e3 inset !important;
  background-color: #f5f5f5;
}

.internal-split .date .el-input__inner {
  height: 36px;
}

.period .date.is-disabled {
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset !important;
}

.total-prod-cost {
  display: flex;
}

.total-prod-cost .btn-groups .el-button + .el-button {
  margin-left: 0px;
}
</style>
